export default {
  instituteCount: '',
  loginStatCount: '',
}
